import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { TTableSkeletonColumn, FLEX_COLUMN_MIN_WIDTH } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'dss-libs-ui-table-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './table-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSkeletonComponent {
  readonly rows = input<number>(10);
  readonly columns = input.required<TTableSkeletonColumn[]>();
  readonly showPagination = input<boolean>(true);

  protected readonly rowsArray = computed(() => Array.from({ length: this.rows() }, (_, index) => index));

  protected readonly minWidth = computed(
    () =>
      `calc(${this.columns()
        .map((column) => column.minWidth ?? FLEX_COLUMN_MIN_WIDTH)
        .join(' + ')})`
  );
}
